module.exports.validateForm = function(jsonString) {
  var errors = [];

  if (!validateJSON(jsonString)) {
    errors.push("Invalid JSON");
    return errors;
  }

  var formJson = JSON.parse(jsonString);

  // Proceed with validation if JSON is valid.  
  if (!formJson.hasOwnProperty("Name")) {
    errors.push("Missing Name attribute");
  }

  if (!formJson.hasOwnProperty("IsActive")) {
    errors.push("Missing IsActive attribute");
  }

  if (!formJson.hasOwnProperty("Version")) {
    errors.push("Missing Version attribute");
  }

  if (!formJson.hasOwnProperty("ModuleType")) {
    errors.push("Missing ModuleType attribute");
  }

  if (!formJson.hasOwnProperty("FormType")) {
    errors.push("Missing FormType attribute");
  }

  return errors;
}

// Checks if the given string is valid json, and returns it if it is
function validateJSON(jsonString) {
  try {
    var o = JSON.parse(jsonString);

    if (o && typeof o === "object") {
      return true;
    }
  } catch (e) {}

  return false;
}